import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function MerchantNoticePopup() {
  const nav = useNavigate();
  const [notice, setNotice] = useState(undefined);

  useEffect(() => {
    api.get("/merchant/notices/active").then(({ data }) => {
      setNotice(data?.id ? data : null);
    }).catch(() => setNotice(null));
  }, []);

  if (!notice) return null;

  const dismiss = async () => {
    try { await api.post(`/merchant/notices/${notice.id}/dismiss`); } catch { /* still close */ }
    setNotice(null);
  };

  const go = async () => {
    const href = notice.href || "/admin/addons";
    await dismiss();
    if (href.startsWith("http://") || href.startsWith("https://")) {
      window.open(href, "_blank", "noopener,noreferrer");
      return;
    }
    nav(href);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center p-4 bg-slate-900/55 backdrop-blur-[2px]" data-testid="sales-notice-modal">
      <div className="relative w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-slate-200">
        <button type="button" onClick={dismiss} className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 shadow flex items-center justify-center text-slate-600" data-testid="sales-notice-dismiss" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
        {notice.image_url && (
          <div className="aspect-[16/9] bg-gradient-to-br from-violet-600 to-indigo-900">
            <img src={mediaUrl(notice.image_url)} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-6 space-y-3">
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-violet-600">From MeraStartup</div>
          <h2 className="font-display text-2xl font-bold text-slate-900 leading-tight">{notice.title}</h2>
          <p className="text-sm text-slate-600 whitespace-pre-wrap leading-relaxed">{notice.body}</p>
          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <Button onClick={go} className="flex-1 rounded-full h-11 bg-violet-600 hover:bg-violet-700" data-testid="sales-notice-cta">
              {notice.cta_label || "View offer"}
            </Button>
            <Button type="button" variant="outline" onClick={dismiss} className="rounded-full h-11" data-testid="sales-notice-later">
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
